// @flow
// eslint-disable-next-line no-unused-vars
import * as React from 'react';
import { useIntl } from 'react-intl';
import {
    Picker, View, useWindowDimensions,
} from 'react-native';
import { APIContext } from 'speed-js-react';
import styles from './ProfileStyles';
import { CATEGORY_NOMENCLATURE_TYPE_CODE, RESOLUTION_NOMENCLATURE_TYPE_CODE } from '../constants';

type Props = {
    filterCategory: Object,
    setFilterCategory: Function,
    filterResolution: Object,
    setFilterResolution: Function,
};

const FilterChannelsInputsForm = (props: Props) => {
    const {
        filterCategory, setFilterCategory, filterResolution, setFilterResolution,
    } = props;

    const { apiClient } = React.useContext(APIContext);
    const { width } = useWindowDimensions();
    const intl = useIntl();

    const [categories, setCategories] = React.useState([]);
    const [resolutions, setResolutions] = React.useState([]);

    React.useEffect(() => {
        apiClient.resources.nomenclatureType.list()
            .then((res) => {
                const categoryNomenclatureItem = res.results.find((el) => el.code === CATEGORY_NOMENCLATURE_TYPE_CODE);
                const resolutionNomenclatureItem = res.results.find(
                    (el) => el.code === RESOLUTION_NOMENCLATURE_TYPE_CODE,
                );
                apiClient.resources.nomenclatureItem.list(categoryNomenclatureItem.id)
                    .then((items) => {
                        setCategories(items.results);
                    });
                apiClient.resources.nomenclatureItem.list(resolutionNomenclatureItem.id)
                    .then((items) => {
                        setResolutions(items.results);
                    });
            })
            .catch(console.log);
        // eslint-disable-next-line
    }, []);

    return (
        <View style={width > 600 ? styles.filter_wrapper : styles.filter_wrapper_phone}>
            <View style={width > 600 && styles.internal_wrapper}>
                <View style={styles.second_inputs}>
                    <Picker
                        style={styles.filter_inputs}
                        selectedValue={filterCategory}
                        onValueChange={(value) => setFilterCategory(value)}
                    >
                        <Picker.Item
                            label={intl.formatMessage({ id: 'category', defaultMessage: 'Category' })}
                            value=""
                        />
                        {categories.map((el) => (
                            <Picker.Item
                                label={el.translations.bg.name}
                                value={el.code}
                                key={el.code}
                            />
                        ))}
                    </Picker>
                    <Picker
                        style={styles.filter_inputs}
                        selectedValue={filterResolution}
                        onValueChange={(value) => setFilterResolution(value)}
                    >
                        <Picker.Item
                            color="blue"
                            label={intl.formatMessage(
                                { id: 'resolution', defaultMessage: 'Resolution' },
                            )}
                            value=""
                        />
                        {resolutions.map((el) => (
                            <Picker.Item
                                label={el.translations.bg.name}
                                value={el.code}
                                key={el.code}
                            />
                        ))}
                    </Picker>
                </View>
            </View>
        </View>
    );
};

export default FilterChannelsInputsForm;
